<div>

  <div class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.GRUENDUNGSFORM.TITEL' | translate }}
    </h2>

    <common-ui-gruendungsform [(data)]="data" [readonly]="readonly"></common-ui-gruendungsform>
  </div>

</div>
